// DS: WEB 9.1 NFT Details Box
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Info from '@wix/da-ds/pkg/Icons/16x16/Info';
import Trashcan from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import OpenSea from '@wix/da-ds/pkg/Icons/24x24/OpenSea';
import Rarible from '@wix/da-ds/pkg/Icons/24x24/Rarible';
import s from './NftDetails.scss';
var marketplaceIcons = {
    OpenSea: OpenSea,
    Rarible: Rarible,
};
var NftDetails = function (_a) {
    var nft = _a.nft, isOwner = _a.isOwner;
    var t = useTranslation().t;
    return (React.createElement(Section, { className: s['root'] },
        React.createElement(Heading, { className: s['heading'] },
            t('deviation.nft.heading'),
            React.createElement(SophisticatedTooltip, { size: "large", heading: t('deviation.nft.heading.tooltip.title'), description: t('deviation.nft.heading.tooltip.text'), className: s['heading-icon'] },
                React.createElement(Info, { size: IconSize.SMALLER })),
            isOwner && (React.createElement(Trashcan, { className: s['remove-icon'] }))),
        React.createElement("ul", { className: s['items'] },
            React.createElement("li", { key: "contract", className: s['item'] },
                React.createElement("dl", null,
                    React.createElement("dt", { className: s['item-name'] }, t('deviation.nft.item.contract')),
                    React.createElement("dd", { className: s['contract'] },
                        React.createElement("span", { className: s['contract-prefix'] }, "0x".concat(nft.blockchainIdentifierPrimary.slice(0, -4))),
                        React.createElement("span", { className: s['contract-postfix'] }, nft.blockchainIdentifierPrimary.slice(-4))))),
            React.createElement("li", { key: "blockchain", className: s['item'] },
                React.createElement("dl", null,
                    React.createElement("dt", { className: s['item-name'] }, t('deviation.nft.item.blockchain')),
                    React.createElement("dd", { className: classnames(s['item-value'], s['blockchain']) }, nft.blockchainName.toLowerCase()))),
            nft.blockchainIdentifierSecondary && (React.createElement("li", { key: "token", className: s['item'] },
                React.createElement("dl", null,
                    React.createElement("dt", { className: s['item-name'] }, t('deviation.nft.item.token')),
                    React.createElement("dd", { className: s['item-value'] }, nft.blockchainIdentifierSecondary))))),
        nft.externalLinks.map(function (link) {
            if (link.type === 'marketplace') {
                return (React.createElement(GhostButton, { className: s['cta'], size: "large", variant: "main", target: "_blank", href: link.url, icon: link.name && marketplaceIcons.hasOwnProperty(link.name)
                        ? marketplaceIcons[link.name]
                        : null }, link.name
                    ? t('deviation.nft.marketplace.named', link)
                    : t('deviation.nft.marketplace.unnamed')));
            }
            return null;
        })));
};
NftDetails.displayName = 'NftDetails';
export default NftDetails;
//# sourceMappingURL=NftDetails.js.map